var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPearsanaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "113px",
    viewBox: "180 496 120 113 ",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "generated by pstoedit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fefefe",
    fillRule: "evenodd",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 191.012 559.289  L 180.305 559.289  L 180.305 608.57  L 189.332 608.57  L 190.785 608.57  C 204.523 608.57 219.324 599.836 219.324 582.988  L 219.324 576.453  L 219.324 560.199  Z  "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#c8caca",
    fillRule: "evenodd",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 191.387 495.43  L 208.141 495.43  L 248.422 495.43  L 260.469 495.43  C 274.457 495.43 286.805 502.797 293.836 513.836  C 286.48 523.629 273.27 530.195 258.277 530.195  L 245.563 530.195  L 203.047 530.195  L 194.711 530.195  L 180.305 540.582  L 180.305 506.516  C 180.305 500.418 185.293 495.43 191.387 495.43  Z  M 297.926 522.352  C 299.27 526.316 300 530.555 300 534.961  L 300 534.961  C 300 556.703 282.211 574.488 260.469 574.488  L 248.422 574.488  L 208.141 574.488  L 200.242 574.488  L 180.305 591.934  L 180.305 556.305  L 194.711 545.918  L 203.047 545.918  L 245.563 545.918  L 258.277 545.918  C 276.707 545.918 292.441 535.996 297.926 522.352  Z  "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fefefe",
    fillRule: "evenodd",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 297.922 522.355  C 298.859 525.125 299.504 528.031 299.805 531.031  C 297.816 547.348 280.887 560.199 260.469 560.199  L 248.422 560.199  L 208.141 560.199  L 199.938 560  L 180 574.289  L 180.082 556.469  L 194.711 545.918  L 203.043 545.918  L 245.563 545.918  L 258.277 545.918  C 276.703 545.918 292.438 535.996 297.922 522.355  Z  "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#c8caca",
    fillRule: "evenodd",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 203.047 530.195  L 245.563 530.195  L 258.277 530.195  C 273.27 530.195 286.48 523.629 293.836 513.836  C 291.512 510.18 288.602 506.93 285.242 504.219  C 277.957 509.297 268.535 512.371 258.277 512.371  L 245.563 512.371  L 203.047 512.371  L 194.711 512.371  L 180.305 522.695  L 180.305 540.523  L 194.711 530.195  Z  "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fefefe",
    fillRule: "evenodd",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 203.043 512.371  L 245.563 512.371  L 258.277 512.371  C 268.535 512.371 277.957 509.297 285.242 504.219  C 278.453 498.727 269.828 495.43 260.469 495.43  L 248.422 495.43  L 208.141 495.43  L 191.387 495.43  L 191.188 495.434  C 191.156 495.434 191.129 495.434 191.102 495.434  C 185.137 495.586 180.305 500.512 180.305 506.512  L 180.305 522.695  L 194.711 512.371  Z  "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#001c45",
    fillRule: "evenodd",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 191.012 559.289  L 180.305 559.289  L 180.305 608.57  L 189.332 608.57  L 190.785 608.57  C 204.523 608.57 219.324 599.836 219.324 582.988  L 219.324 576.453  L 219.324 560.199  Z  "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#be092f",
    fillRule: "evenodd",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 191.387 495.43  L 208.141 495.43  L 248.422 495.43  L 260.469 495.43  C 274.457 495.43 286.805 502.797 293.836 513.836  C 286.48 523.629 273.27 530.195 258.277 530.195  L 245.563 530.195  L 203.047 530.195  L 194.711 530.195  L 180.305 540.582  L 180.305 506.516  C 180.305 500.418 185.293 495.43 191.387 495.43  Z  M 297.926 522.352  C 299.27 526.316 300 530.555 300 534.961  L 300 534.961  C 300 556.703 282.211 574.488 260.469 574.488  L 248.422 574.488  L 208.141 574.488  L 200.242 574.488  L 180.305 591.934  L 180.305 556.305  L 194.711 545.918  L 203.047 545.918  L 245.563 545.918  L 258.277 545.918  C 276.707 545.918 292.441 535.996 297.926 522.352  Z  "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d9113c",
    fillRule: "evenodd",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 297.922 522.355  C 298.859 525.125 299.504 528.031 299.805 531.031  C 297.816 547.348 280.887 560.199 260.469 560.199  L 248.422 560.199  L 208.141 560.199  L 199.938 560  L 180 574.289  L 180.082 556.469  L 194.711 545.918  L 203.043 545.918  L 245.563 545.918  L 258.277 545.918  C 276.703 545.918 292.438 535.996 297.922 522.355  Z  "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#be092f",
    fillRule: "evenodd",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 203.047 530.195  L 245.563 530.195  L 258.277 530.195  C 273.27 530.195 286.48 523.629 293.836 513.836  C 291.512 510.18 288.602 506.93 285.242 504.219  C 277.957 509.297 268.535 512.371 258.277 512.371  L 245.563 512.371  L 203.047 512.371  L 194.711 512.371  L 180.305 522.695  L 180.305 540.523  L 194.711 530.195  Z  "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d9113c",
    fillRule: "evenodd",
    strokeWidth: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 203.043 512.371  L 245.563 512.371  L 258.277 512.371  C 268.535 512.371 277.957 509.297 285.242 504.219  C 278.453 498.727 269.828 495.43 260.469 495.43  L 248.422 495.43  L 208.141 495.43  L 191.387 495.43  L 191.188 495.434  C 191.156 495.434 191.129 495.434 191.102 495.434  C 185.137 495.586 180.305 500.512 180.305 506.512  L 180.305 522.695  L 194.711 512.371  Z  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPearsanaIcon);
export default __webpack_public_path__ + "static/media/pearsana-icon.d90a58edc5125ab9720c53dde0d74aee.svg";
export { ForwardRef as ReactComponent };